import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft, Wallet } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { fmtCurrencyExact } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import RentTimeline, { monthsForContract } from "@/components/RentTimeline";

export default function PaymentDetail() {
  const { id } = useParams();
  const { t } = useI18n();
  const navigate = useNavigate();

  const { data: contracts = [] } = useQuery({ queryKey: ["contracts"], queryFn: async () => (await api.get("/contracts")).data });
  const { data: properties = [] } = useQuery({ queryKey: ["properties"], queryFn: async () => (await api.get("/properties")).data });
  const { data: tenants = [] } = useQuery({ queryKey: ["tenants"], queryFn: async () => (await api.get("/tenants")).data });

  const contract = contracts.find((c) => c.id === id);
  const propName = (pid) => properties.find((p) => p.id === pid)?.name || "—";
  const tenantName = (tid) => tenants.find((x) => x.id === tid)?.name || "—";

  return (
    <div className="space-y-6" data-testid="payment-detail-page">
      <Button variant="ghost" onClick={() => navigate("/payments")} data-testid="back-btn" className="gap-2 -ml-2">
        <ArrowLeft className="h-4 w-4" /> {t("back")}
      </Button>

      {!contract ? (
        <div className="h-64 flex items-center justify-center text-muted-foreground">…</div>
      ) : (
        <>
          <div className="flex items-start justify-between gap-4 flex-wrap">
            <div className="flex items-center gap-4">
              <div className="h-12 w-12 rounded-sm bg-secondary flex items-center justify-center">
                <Wallet className="h-6 w-6" />
              </div>
              <div>
                <h1 className="font-display text-4xl">{propName(contract.property_id)} — {tenantName(contract.tenant_id)}</h1>
                <p className="text-sm text-muted-foreground mt-1">{fmtCurrencyExact(contract.rent_amount)}{t("billing_per_month")}</p>
              </div>
            </div>
            <Badge className="rounded-sm bg-[hsl(var(--success))] text-white">{contract.status}</Badge>
          </div>

          <Card className="p-6 rounded-sm border-border">
            <RentTimeline contract={contract} months={monthsForContract(contract)} />
          </Card>
        </>
      )}
    </div>
  );
}
